import { render } from "./singleWithoutParts.vue?vue&type=template&id=d9470e4c&ts=true"
import script from "./singleWithoutParts.vue?vue&type=script&lang=ts"
export * from "./singleWithoutParts.vue?vue&type=script&lang=ts"

import "./singleWithoutParts.vue?vue&type=style&index=0&id=d9470e4c&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__